import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import { CampaignMessageStore } from '@seedlang/stores';
import { Link } from 'react-router';
import Grid from 'components/layout/grid';

@observer
class CampaignMessageShow extends React.Component {

  constructor(props) {
    super(props);
    CampaignMessageStore.getShow({ids: {campaignMessageId: this.props.params.campaignMessageId}});
  }

  render() {
    if (CampaignMessageStore.hasShowData) {
      return (
        <div className='mailings-show'>
          <Grid columns={2} gap='sm'>
            <fieldset>
              <legend>User</legend>
              <Link
                to={{ name: 'builder.users.edit', params: { userId: CampaignMessageStore.showData.user.id } }}
                className='on-click'
              >
                {CampaignMessageStore.showData.user.name}
              </Link>
            </fieldset>
            <fieldset>
              <legend>Subject</legend>
              {CampaignMessageStore.showData.campaign?.subject}
            </fieldset>
          </Grid>
          <fieldset>
            <legend>Title</legend>
            <div
              dangerouslySetInnerHTML={{ __html: CampaignMessageStore.showData.campaign?.title }}
            />
          </fieldset>
          <fieldset>
            <legend>Body</legend>
            <div
              dangerouslySetInnerHTML={{ __html: CampaignMessageStore.showData.campaign?.mailingBody }}
            />
          </fieldset>
        </div>
      );
    }
    return <span />;
  }
}

export default ErrorBoundary(CampaignMessageShow);
